module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray@3x-d4adc06df55c3dc35aee19a3e22c0508.png";